import { colors } from './const';
import { resolveLiveSurveyDevUrl } from './detect-framework';
import { runFillImplementationPlan } from './fill-implementation-plan';
import { writeLayoutAuditFile } from './layout-audit';
import { writeLayoutTasksFile } from './layout-tasks';
import { writeMcqOtherTasksFile } from './mcq-other-tasks';
import { printSurveyTypeInstallBlock } from './install-manifest';
import { resolveProjectRoot } from './resolve-project-root';
import { formatLayoutBlockedFooter } from './workflow-prompts';
import { getErrorMessage } from '../types/shared';
import * as path from 'path';

const c = colors;

export interface SyncFromFetchOptions {
  projectRoot?: string;
  instanceIdOverride?: string;
}

/** INPUT 2 post-smoke: fill the implementation plan from the live fetch (§0, §3b–§3e). */
export async function runSyncFromFetch(options: SyncFromFetchOptions = {}): Promise<number> {
  const projectRoot = resolveProjectRoot(options.projectRoot);

  console.log(`${c.bold}=== CFM SDK — sync-from-fetch ===${c.reset}`);
  console.log(`${c.dim}Project: ${projectRoot}${c.reset}\n`);

  try {
    const { planPath, surveyTypes, hasMcqOtherPickers, matrixVariants, mcqOtherRows } =
      await runFillImplementationPlan({
      projectRoot,
      instanceIdOverride: options.instanceIdOverride,
    });
    console.log(`${c.green}✅ Patched ${planPath} from live fetch (§0, §3b–§3e)${c.reset}`);

    const auditPath = writeLayoutAuditFile(projectRoot, matrixVariants);
    const tasksPath = writeLayoutTasksFile(projectRoot, matrixVariants);
    const mcqTasksPath = writeMcqOtherTasksFile(projectRoot, mcqOtherRows, hasMcqOtherPickers);
    console.log(
      `${c.green}✅ Wrote ${path.basename(auditPath)}, ${path.basename(tasksPath)}, and ${path.basename(mcqTasksPath)}${c.reset}`,
    );

    printSurveyTypeInstallBlock(projectRoot, surveyTypes, hasMcqOtherPickers);
    console.log(
      `${c.dim}Implement §3c layout branches — see layout-tasks.md · audit in layout-audit.md${c.reset}`,
    );
    const { warning } = await resolveLiveSurveyDevUrl(projectRoot);
    if (warning) {
      console.log(`${c.yellow}⚠️  ${warning}${c.reset}`);
    }
    console.log(`\n${formatLayoutBlockedFooter()}\n`);
    console.log(`${c.dim}Next: npx cfm-sdk verify-layout --from-fetch${c.reset}`);
    return 0;
  } catch (err: unknown) {
    console.error(`\n${c.red}❌ ${getErrorMessage(err)}${c.reset}`);
    console.error(
      `${c.dim}Fallback: npx cfm-sdk fill-implementation-plan --from-fetch${c.reset}`,
    );
    return 1;
  }
}
